import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchOrganization,
  updateOrganization,
} from "../../../../ReduxSlices/Admin/organizationDataSlice";
import LoadingDots from "../../../shared/LoadingDots";

const OrganizationPanel = () => {
  const dispatch = useDispatch();
  const org = useSelector((state) => state.organization.data);
  const submitting = useSelector(state => state.organization.submitting);

  const [editing, setEditing] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!org) {
      dispatch(fetchOrganization());
    }
  }, [dispatch]);

  useEffect(() => {
    if (org) {
      setName(org.name || "");
      setPhone(org.phone_number || "");
      setCity(org.city || "");
      setCountry(org.country || "");
      setPreview(org.logo_url || null);
    }
  }, [org]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLogoFile(file);
    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);
  };

  useEffect(() => {
    return () => {
      if (preview?.startsWith("blob:")) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const handleCancel = () => {
  if (org) {
    setName(org.name || "");
    setPhone(org.phone_number || "");
    setCity(org.city || "");
    setCountry(org.country || "");
    setPreview(org.logo_url || null);
  }

  setLogoFile(null);
  setEditing(false);
};

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("organization[name]", name);
    formData.append("organization[phone_number]", phone);
    formData.append("organization[city]", city);
    formData.append("organization[country]", country);

    if (logoFile) formData.append("organization[logo]", logoFile);

    dispatch(updateOrganization(formData));
    setEditing(false);
    setLogoFile(null);
  };

  if (!org) {
  return (
    <div className="p-6 ">
      <LoadingDots />
    </div>
  );
}

  return (
    <div className="org-data">

      <h2 className="text-2xl font-semibold mb-6">Account Settings</h2>

      {!editing ? (
        <div className="space-y-6">

          <div className="grid w-[60%] grid-cols-2 gap-6 text-sm">

            <div>
              <p>Clinic name:</p>
              <h3 className="text-lg font-medium">{org.name}</h3>
              </div>

            <div>
              <p>Account logo:</p>
              {org.logo_url && (
                <img
                  src={org.logo_url}
                  alt="logo"
                  className="w-[60px]"
                />
              )}
            </div>      
   
          </div>

          <div className="grid w-[60%] grid-cols-2 gap-6 text-sm">

            <div>
              <p className="text-gray-500">Contact Details:</p>
              <h3 className="font-medium">{org.phone_number}</h3>
            </div>

            <div>
              <p className="text-gray-500">Address:</p>
              <h3 className="font-medium">
                {org.city}, {org.country}
              </h3>
            </div>

          </div>

          <button
            onClick={() => setEditing(true)}
            className="primary"
          >
            Edit Details
          </button>

        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6 flex flex-col gap-[10px]">

          <div className="flex flex-col gap-[3px]"> 
            <label className="block text-sm text-gray-600 mb-1">
             Clinic Name
            </label> 

            <input
              className="w-1/2 border rounded-lg p-2 focus:ring-2 focus:ring-blue-400"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="flex flex-col gap-[3px]">
            <label className="block text-sm text-gray-600 mb-1">
              Phone Number
            </label>

            <input
              className="w-1/2 border rounded-lg p-2 focus:ring-2 focus:ring-blue-400"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-[3px]">

            <div>
              <label className="block text-sm text-gray-600 mb-1">
                City
              </label>

              <input
                className="w-1/2 border rounded-lg p-2"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className="flex flex-col gap-[3px]">
              <label className="block text-sm text-gray-600 mb-1">
                Country
              </label>

              <input
                className="w-1/2 border rounded-lg p-2"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              />
            </div>

          </div>

          <div className="flex flex-col gap-[3px]">
            <label className="block text-sm text-gray-600 mb-2">
              Clinic Logo
            </label>

            <input type="file" accept="image/*" onChange={handleLogoChange} />

            {preview && (
              <img
                src={preview}
                alt="preview"
                className="img-preview"
              />
            )}
          </div>

          <div className="flex gap-[20px] ">

            <button
              type="submit"
              disabled={submitting}
              className="primary"
            >
              {submitting ? "Saving.." : "Save"}
            </button>

            <button
              type="button"
              onClick={handleCancel}
              className="secondary"
            >
              Cancel
            </button>

          </div>

        </form>
      )}
    </div>
  );
};

export default OrganizationPanel;